"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.slice.js");

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.array.find.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.regexp.to-string.js");

require("core-js/modules/es6.function.name.js");

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../../../lib/utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _dovePlaceholder2x = _interopRequireDefault(require("../../../../images/dove-placeholder@2x.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserSection = function UserSection(props) {
  var user = props.user,
      inbox = props.inbox,
      isAnncListOpen = props.isAnncListOpen,
      anncCount = props.anncCount,
      anncDisplayCount = props.anncDisplayCount,
      viewMoreIncrement = props.viewMoreIncrement,
      handleViewMore = props.handleViewMore,
      toggleAnncList = props.toggleAnncList,
      currentPage = props.currentPage;
  var slicedInbox = inbox && inbox.sort(function (a, b) {
    return b.creationDate - a.creationDate;
  }).slice(0, anncDisplayCount) || [];
  var userAnncClasses = (0, _classnames.default)('user-announcements', {
    open: isAnncListOpen,
    small: anncDisplayCount > 3,
    medium: anncDisplayCount > 3 + viewMoreIncrement,
    large: anncDisplayCount > 3 + viewMoreIncrement * 3,
    xlarge: anncDisplayCount > 3 + viewMoreIncrement * 8
  });

  var mapAnnouncements = function mapAnnouncements() {
    return slicedInbox.map(function (annc) {
      var isUserAdmin = annc.accessors.find(function (accessor) {
        var _accessor$userRef, _accessor$userRef$_id, _user$_id;

        return (accessor === null || accessor === void 0 ? void 0 : (_accessor$userRef = accessor.userRef) === null || _accessor$userRef === void 0 ? void 0 : (_accessor$userRef$_id = _accessor$userRef._id) === null || _accessor$userRef$_id === void 0 ? void 0 : _accessor$userRef$_id.toString()) === (user === null || user === void 0 ? void 0 : (_user$_id = user._id) === null || _user$_id === void 0 ? void 0 : _user$_id.toString()) && accessor.type !== 'viewer';
      });
      return /*#__PURE__*/_react.default.createElement("li", {
        key: annc._id,
        className: "user-announcement"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "/r/memorial/".concat(annc._id, "?skipMat=true"),
        onClick: (0, _utils.googleAnalytics)("memorial")
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "announcement-image",
        style: {
          backgroundImage: "url(".concat(annc.image || _dovePlaceholder2x.default, ")")
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "announcement-details"
      }, /*#__PURE__*/_react.default.createElement("h5", {
        className: "decedent-name"
      }, (0, _utils.nameString)(annc.name)), /*#__PURE__*/_react.default.createElement("span", {
        className: "announcement-status"
      }, !!isUserAdmin ? 'Admin' : 'Following'))));
    });
  };

  var renderAnnouncements = function renderAnnouncements() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: userAnncClasses
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "announcements-header",
      onClick: function onClick() {
        toggleAnncList();
        (0, _utils.googleAnalytics)('announcements')();
      }
    }, /*#__PURE__*/_react.default.createElement("h4", null, "Invites"), /*#__PURE__*/_react.default.createElement("div", {
      className: "triangle-icon"
    })), /*#__PURE__*/_react.default.createElement("ul", {
      className: "announcement-list"
    }, mapAnnouncements()), !!anncCount && anncCount > anncDisplayCount && /*#__PURE__*/_react.default.createElement("a", {
      className: "view-more-announcements",
      href: "#",
      onClick: function onClick() {
        (0, _utils.googleAnalytics)('view_more')();
        handleViewMore();
      }
    }, "View More"));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-menu-user-section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "user-profile"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: user.image || _dovePlaceholder2x.default,
    alt: "The user"
  }), /*#__PURE__*/_react.default.createElement("span", null, (0, _utils.nameString)(user.name))), !!slicedInbox.length && currentPage !== 'dash' && renderAnnouncements());
};

var _default = UserSection;
exports.default = _default;